// import { BASE_URL } from '@/api/url';
// import BaseFuncApi from '@/api/base/commonFunc-api';
// import Enum from '@/enum/enum';
import CategoryClient from "@/api/category/category-client";
const categoryClient = new CategoryClient();
export default {
  createCategory: async function (context, payload) {
    var result = await categoryClient.postAsync(
      {
        url: `${categoryClient.url}`,
        data: payload,
      },
      true
    );
    if (result) {
      return result;
    }
    return null;
  },

  updateCategory: async function (context, payload) {
    var result = await categoryClient.putAsync(
      {
        url: `${categoryClient.url}/${payload.id}`,
        data: payload,
      },
      true
    );
    if (result) {
      return result;
    }
    return null;
  },

  deleteCategory: async function (context, payload) {
    var result = await categoryClient.deleteAsync(
      {
        url: `${categoryClient.url}/${payload.id}`,
        queries: { isSoft: true },
      },
      true
    );
    return result;
  },

  getCategory: async function (context, payload) {
    var result = await categoryClient.getAsync(
      {
        url: `${categoryClient.url}/${payload.id}/detail`,
        data: payload,
      },
      true
    );
    if (result && result.data) {
      return result.data;
    }
    return null;
  },

  getCategories: async function (context, payload) {
    var result = await categoryClient.getAsync(
      {
        url: `${categoryClient.url}/search`,
        queries: payload,
      },
      true
    );
    if (result && result.data) {
      context.commit("updateTotalPage", result.data);
      return result.data;
    }
    return null;
  },

  getCategoriesList: async function (context, payload) {
    var result = await categoryClient.getAsync(
      {
        url: `${categoryClient.url}/search`,
        queries: payload,
      },
      true
    );
    if (result && result.data && result.data.rows) {
      context.commit("updateCategories", result.data.rows);
      return result.data.rows;
    }
    return [];
  },
};
